import React, { useEffect, useState } from 'react'
import TableInput from '../../../dpe-usco/components/Table/TableInput/TableInput'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button } from 'syngenta-react-components'

const PLANTING_HEADERS = [
  'Name',
  'Total Planted Acres',
  'Planting Date',
  'Planting Rate',
  'Est. Bu/Acres'
]


export const PlantingSteward = ({ isTotalfield, plantingData, setPlantingData, updateRowData, modalCallBack, isActiveWidget, setIsActiveWidget, replantOrLost }) => {
  const[isChecked, setIsChecked] = useState(false)
  const[firstRow, setFirstRow] = useState(0)
  const[isFieldAvailable, setIsFieldAvailable] = useState(false)
  const [plantingDataFormated, setPlantingDataFormated] = useState(plantingData)

  useEffect(()=> {
    if(plantingData.length > 0) {
      const formattedData = plantingData.map(item => {
        let formattedDate = item.date
        if (item.date.includes('T')) {
          formattedDate = item.date.split('T')[0]
        }
        return { ...item, date: formattedDate }
      })
      setPlantingDataFormated(formattedData)
    }
  },[plantingData])

  const handleClickPlantingDate = e => {
    if(plantingData.length){
      const plantingDataArr = plantingData.map((data, index) => ( replantOrLost[index]?.fieldLost ? { ...data } : { ...data, date: e.target.value } ))
      setPlantingData(plantingDataArr)
    }
  }

  useEffect(() => {
    if(replantOrLost.length > 0 && !isTotalfield) {
      const index = replantOrLost.findIndex(data => !data?.fieldLost )
      setFirstRow(index)
      if(index === -1) {
        setIsFieldAvailable(false)
      } else {
        setIsFieldAvailable(true)
      }
    }
  }, [replantOrLost, isTotalfield ])

  const checked = e => {
    setIsChecked(prev => !prev)
    if(e.target.checked){
      const plantingDataArr = plantingData.map((data, index) => ( replantOrLost[index]?.fieldLost ? { ...data } : { ...data, date: plantingData[firstRow].date }) )
      setPlantingData(plantingDataArr)
    }
  }

  const mapHeaders = headerArray => {
    return headerArray.map(header => {
      return {
        value: header,
        format() {
          return headerCell(header)
        }
      }
    })
  }
  const headerCell = value => {
    return (
      <div key={value} className={`${value} cell`}>
        <div>{value}</div>
      </div>
    )
  }
  
  const plantingStructure = {
    headers: mapHeaders(PLANTING_HEADERS),
    dataKeys: [
      'name', 
      'total_planted_acres', 
      'plant_date', 
      'planting_rate', 
      'crop',
      'date'
    ],
    format: {
      name: val => {
        return <div className='cell'>{val}</div>
      },
      total_planted_acres: (val, onChange) => {
        return (
          <input
            placeholder='Total acres'
            aria-label='plantedAcres'
            className='interff w150'
            key='Acres'
            onChange={onChange}
            type='number'
            value={val}
          />
        )
      },
      date: (val, onChange, index) => {
        return (
          <input
            role='grid'
            aria-label='plantedDate'
            className='interff w150'
            key='plant_date'
            onChange={isChecked? e => handleClickPlantingDate(e):onChange}
            type='date'
            value={val}
            disabled ={isChecked && index !== firstRow ? true : false}
          />
        )
      },
      planting_rate: (val, onChange) => {
        return (
          <input
            placeholder='Planting rate'
            aria-label='plantedRate'
            className='interff w150'
            key='plant_rate'
            onChange={onChange}
            type='number'
            value={val}
          />
        )
      },
      crop: (val, onChange) => {
        return (
          <input
            placeholder='Est. bu/acre'
            aria-label='plantedCrop'
            className='interff w150'
            key='bushels'
            onChange={onChange}
            type='number'
            value={val}
          />
        )
      }
    }
  }

  const clickHandler = () => {
    setIsChecked(false)
    setIsActiveWidget('PLANTING')
  }

  let buttons = (
    <Button disabled={(isActiveWidget && isActiveWidget !== 'PLANTING') || isTotalfield  || !isFieldAvailable} text='Edit planting stewardship' clickHandler={clickHandler} />)
  if (isActiveWidget === 'PLANTING'){
    buttons = (
      <div className='100% tar'>
        <Button customClassName='mr10' type='default' text='Cancel' clickHandler={() => modalCallBack('DISCARD')}/>
        <Button customClassName='mr10' type='success' text='Save' clickHandler={() => modalCallBack('PLANTING')}/>
      </div>)
  }
   
  return (
    <Widget dataTestId='plantingStewardshipTable' title='Planting Stewardship' button={buttons}>
      <TableInput structure={plantingStructure} data={plantingDataFormated} updateRowData={updateRowData} editMode={isActiveWidget === 'PLANTING'} replantOrLost={replantOrLost}></TableInput>
      <div className="pl16 mt10" style={{ display: isActiveWidget === 'PLANTING' ? 'block' : 'none' }}>
        <input
          className="w15"
          type="checkbox"
          id="samePlantingDate"
          onChange={e => checked(e)}
          checked={isChecked}
        />
        <label htmlFor="samePlantingDate">
          Use the same Planting Date.
        </label>
      </div>
    </Widget>
  )
}

export default PlantingSteward